export default "__VITE_ASSET__69b832c1__"